"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialActivationButtonPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var TrialActivationButtonPropsInterface = {
  trialId: _propTypes.default.number,
  shouldHideSurvey: _propTypes.default.bool,
  onSuccess: _propTypes.default.func,
  successModalHeader: _propTypes.default.node,
  successModalSubText: _propTypes.default.node,
  successModalCtaText: _propTypes.default.node,
  showSuccessModalIllustration: _propTypes.default.bool
};
exports.TrialActivationButtonPropsInterface = TrialActivationButtonPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/trial/TrialPropsInterface.js
// module id = 468
// module chunks = 5 6